(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_11bef60"] && !Shopify.designMode) return;
  try {
    const premiumProductCarouselStates = new WeakMap();

  function initializePremiumProductCarousel(container) {
    if (premiumProductCarouselStates.has(container)) return;

    const track = container.querySelector('[data-product-track]');
    const cards = track ? Array.from(track.children) : [];
    const controls = container.querySelector('[data-carousel-controls]');
    const previousButton = container.querySelector('[data-carousel-previous]');
    const nextButton = container.querySelector('[data-carousel-next]');

    if (!track || cards.length < 2) return;

    const controller = new AbortController();
    const signal = controller.signal;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoScrollEnabled = container.dataset.autoProductCarousel === 'true';
    const interval = Number.parseInt(container.dataset.autoProductInterval, 10) || 4000;

    let activeIndex = 0;
    let timer = null;
    let restartTimer = null;
    let resizeObserver = null;
    let isHovering = false;

    function canScroll() {
      return track.scrollWidth - track.clientWidth > 2;
    }

    function getMetrics() {
      const trackStyles = window.getComputedStyle(track);
      const firstCardWidth = cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const paddingStart = Number.parseFloat(trackStyles.paddingInlineStart) || 0;
      const paddingEnd = Number.parseFloat(trackStyles.paddingInlineEnd) || 0;
      const availableWidth = Math.max(
        0,
        track.clientWidth - paddingStart - paddingEnd
      );

      const visibleCount = Math.max(
        1,
        Math.floor(
          (availableWidth + gap + 1) /
          (firstCardWidth + gap)
        )
      );

      const maximumIndex = Math.max(
        0,
        cards.length - visibleCount
      );

      return {
        maximumIndex,
        paddingStart
      };
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      if (restartTimer) window.clearTimeout(restartTimer);

      timer = null;
      restartTimer = null;
    }

    function scrollToCard(index) {
      const {
        maximumIndex,
        paddingStart
      } = getMetrics();

      activeIndex = Math.max(
        0,
        Math.min(index, maximumIndex)
      );

      const card = cards[activeIndex];

      const maximumScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      const target = Math.max(
        0,
        Math.min(
          card.offsetLeft - track.offsetLeft - paddingStart,
          maximumScroll
        )
      );

      track.scrollTo({
        left: target,
        behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
      });
    }

    function move(direction) {
      const {
        maximumIndex
      } = getMetrics();

      if (!canScroll() || maximumIndex === 0) return;

      if (direction > 0) {
        scrollToCard(
          activeIndex >= maximumIndex
            ? 0
            : activeIndex + 1
        );
      } else {
        scrollToCard(
          activeIndex <= 0
            ? maximumIndex
            : activeIndex - 1
        );
      }
    }

    function start() {
      stop();

      if (
        !autoScrollEnabled ||
        reducedMotionQuery.matches ||
        document.hidden ||
        isHovering ||
        container.matches(':focus-within') ||
        !canScroll()
      ) return;

      timer = window.setInterval(
        () => move(1),
        interval
      );
    }

    function restartAfterInteraction() {
      stop();

      if (
        !autoScrollEnabled ||
        reducedMotionQuery.matches ||
        document.hidden ||
        isHovering ||
        container.matches(':focus-within') ||
        !canScroll()
      ) return;

      restartTimer = window.setTimeout(() => {
        restartTimer = null;
        move(1);
        start();
      }, interval);
    }

    function updateActiveIndex() {
      const {
        maximumIndex,
        paddingStart
      } = getMetrics();

      const currentPosition =
        track.scrollLeft + paddingStart;

      let closestDistance =
        Number.POSITIVE_INFINITY;

      cards
        .slice(0, maximumIndex + 1)
        .forEach((card, index) => {
          const cardPosition =
            card.offsetLeft - track.offsetLeft;

          const distance =
            Math.abs(
              cardPosition - currentPosition
            );

          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });
    }

    function updateControls() {
      if (!controls) return;

      controls.hidden =
        mobileQuery.matches || !canScroll();
    }

    function refresh() {
      updateActiveIndex();
      updateControls();
      start();
    }

    if (previousButton) {
      previousButton.addEventListener(
        'click',
        () => {
          stop();
          move(-1);
          restartAfterInteraction();
        },
        {
          signal
        }
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        () => {
          stop();
          move(1);
          restartAfterInteraction();
        },
        {
          signal
        }
      );
    }

    track.addEventListener(
      'pointerdown',
      stop,
      {
        signal
      }
    );

    track.addEventListener(
      'pointerup',
      restartAfterInteraction,
      {
        signal
      }
    );

    track.addEventListener(
      'pointercancel',
      restartAfterInteraction,
      {
        signal
      }
    );

    track.addEventListener(
      'scroll',
      updateActiveIndex,
      {
        passive: true,
        signal
      }
    );

    container.addEventListener(
      'focusin',
      stop,
      {
        signal
      }
    );

    container.addEventListener(
      'focusout',
      restartAfterInteraction,
      {
        signal
      }
    );

    container.addEventListener(
      'mouseenter',
      () => {
        isHovering = true;
        stop();
      },
      {
        signal
      }
    );

    container.addEventListener(
      'mouseleave',
      () => {
        isHovering = false;
        restartAfterInteraction();
      },
      {
        signal
      }
    );

    document.addEventListener(
      'visibilitychange',
      start,
      {
        signal
      }
    );

    mobileQuery.addEventListener(
      'change',
      refresh,
      {
        signal
      }
    );

    reducedMotionQuery.addEventListener(
      'change',
      start,
      {
        signal
      }
    );

    resizeObserver =
      new ResizeObserver(refresh);

    resizeObserver.observe(track);

    premiumProductCarouselStates.set(
      container,
      {
        destroy() {
          stop();

          if (resizeObserver) {
            resizeObserver.disconnect();
          }

          controller.abort();

          premiumProductCarouselStates.delete(
            container
          );
        }
      }
    );

    refresh();
  }

  function initializeAllPremiumProductCarousels(root = document) {
    root
      .querySelectorAll('[data-product-carousel]')
      .forEach(initializePremiumProductCarousel);
  }

  function destroyAllPremiumProductCarousels(root) {
    root
      .querySelectorAll('[data-product-carousel]')
      .forEach((container) => {
        const state =
          premiumProductCarouselStates.get(container);

        if (state) {
          state.destroy();
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAllPremiumProductCarousels(),
      {
        once: true
      }
    );
  } else {
    initializeAllPremiumProductCarousels();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllPremiumProductCarousels(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      destroyAllPremiumProductCarousels(
        event.target
      );
    }
  );
  } catch(e) { console.error(e); }
})();

})();
